import PlusIcon from "components/Icons/PlusIcon"
import {
  AddFoodButton,
  FoodBottomInfo,
  FoodBrand,
  FoodImageBox,
  FoodInfoBox,
  FoodLeft,
  FoodName,
  FoodNameBox,
  FoodNutrient,
  MealUnitAndPortionBox,
  StyledMealListItem,
} from "./styled"
import Highlighter from "react-highlight-words"
import { formatDisplayNumber, getDisplayCalories } from "utils"
import { useLayoutEffect, useRef, useState } from "react"
import { useAddedFoodAnimation } from "features/food/hooks/animation"
import SmallFoodImage from "components/foodDetails/share/SmallFoodImage"
import MyFoodIcon from "components/Icons/MyFood"
import { useFoodBrandMaxWidth } from "utils/hooks"
import { formatUnit } from "utils/formater"
import { MealType } from "model/food/types"
import {
  isEdamaMeal,
  isOpenFoodFactMeal,
} from "model/food/utils/typeGuards/mealTypeGuards"
import { isMyFood } from "model/food/utils/typeGuards/foodTypeGuards"
import useDisplayFoodBottomLine from "features/food/hooks/useDisplayFoodBottomLine"

const AddedButton = () => {
  const style = useAddedFoodAnimation()

  return (
    <AddFoodButton style={{ cursor: "default" }}>
      <svg
        style={{ transform: `scale(${style.scale})`, opacity: style.opacity }}
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
      >
        <rect width="32" height="32" rx="16" fill="#0FBDD4" />
        <path
          d="M24 10L13 21L8 16"
          stroke="white"
          strokeWidth="3.42857"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </AddFoodButton>
  )
}

const MealListItem = ({
  meal,
  keyword,
  onAdd,
  onSelect,
}: {
  meal: MealType
  keyword?: string
  onAdd: (meal: MealType) => void
  onSelect?: (meal: MealType) => void
}) => {
  const { name, imageUrl, calorie, carbohydrate, protein, fat } = meal

  const [showAddedIcon, setShowAddedIcon] = useState(false)

  const brand = isEdamaMeal(meal) || isOpenFoodFactMeal(meal) ? meal.brand : ""

  const handleAddMeal = () => {
    onAdd(meal)
    setShowAddedIcon(true)
    setTimeout(() => {
      setShowAddedIcon(false)
    }, 1000)
  }

  const {
    containerRef,
    unitRef,
    brandRef,
    brandMaxWidth,
    unitMaxWidth,
  } = useDisplayFoodBottomLine(brand)

  return (
    <StyledMealListItem>
      <FoodLeft
        onClick={() => {
          onSelect?.(meal)
        }}
      >
        <FoodImageBox>
          <SmallFoodImage src={imageUrl} />
        </FoodImageBox>
        <FoodInfoBox>
          <FoodNameBox>
            <FoodName>
              {" "}
              {keyword ? (
                <Highlighter
                  highlightClassName="high-light-text"
                  searchWords={keyword.split(" ")}
                  autoEscape={true}
                  textToHighlight={name}
                />
              ) : (
                name
              )}
            </FoodName>
            {isMyFood(meal) && <MyFoodIcon />}{" "}
          </FoodNameBox>

          <FoodBottomInfo ref={containerRef}>
            <MealUnitAndPortionBox>
              <FoodNutrient ref={unitRef} style={{ maxWidth: unitMaxWidth }}>
                {getDisplayCalories(calorie)} cal,{" "}
                {formatDisplayNumber(meal.portion, 2)}{" "}
                {formatUnit(meal.unit, isEdamaMeal(meal))} 
              </FoodNutrient>
            </MealUnitAndPortionBox>

            {brand && (
              <FoodBrand ref={brandRef} style={{ maxWidth: brandMaxWidth }}>
                <p> {brand}</p>
              </FoodBrand>
            )}
          </FoodBottomInfo>
        </FoodInfoBox>
      </FoodLeft>

      {showAddedIcon ? (
        <AddedButton />
      ) : (
        <AddFoodButton onClick={handleAddMeal}>
          <PlusIcon />
        </AddFoodButton>
      )}
    </StyledMealListItem>
  )
}

export default MealListItem
